'use client';
import styled, { css } from 'styled-components';
import { defaultStyles } from '../../mixins/defaultStyles.js';
import { spaceProp } from '../../mixins/spaceProp.js';
import { textColorProp } from '../../mixins/textColorProp.js';
import { textStyle } from '../../mixins/textStyle.js';

const Text = styled.span.withConfig({
  shouldForwardProp: (prop, defaultValidatorFn) => !['type', 'color'].includes(prop) && defaultValidatorFn(prop)
}).withConfig({
  componentId: "sc-v665jq-0"
})(["", ";", " ", " display:inline-block;", ";", ";"], ({
  type
}) => textStyle(type), ({
  color
}) => textColorProp(color), ({
  spaceAfter
}) => spaceProp(spaceAfter), ({
  isBlock
}) => isBlock && css(["display:block;"]), ({
  isTruncated
}) => isTruncated && defaultStyles.ellipsis);

export { Text };
//# sourceMappingURL=Text.js.map
